export const ANIMAL_IMAGES = {
  inactiveFoundation: require("./foundation/inactive.webp"),
  activeFoundation: require("./foundation/active.webp"),
  inactiveYear1: require("./year1/inactive.webp"),
  activeYear1: require("./year1/active.webp"),
  inactiveYear2: require("./year2/inactive.webp"),
  activeYear2: require("./year2/active.webp"),
  inactiveYear3: require("./year3/inactive.webp"),
  activeYear3: require("./year3/active.webp"),
  inactiveYear4: require("./year4/inactive.webp"),
  activeYear4: require("./year4/active.webp"),
  inactiveYear5: require("./year5/inactive.webp"),
  activeYear5: require("./year5/active.webp"),
  inactiveYear6: require("./year6/inactive.webp"),
  activeYear6: require("./year6/active.webp"),
};
